import { useState } from 'react'
import Select from "react-select"
import { GuestLogin, Me, SetToken, SetUser } from 'services/Session'
import { CreateUser } from 'services/User'

export function registerForm(props) {
	const inputClass = [
		'bg-gray-50',
		'block',
		'border',
		'border-gray-300',
		'p-2.5',
		'rounded-md',
		'w-full',
		'dark:bg-gray-700',
		'dark:border-gray-600',
		'dark:focus:border-sky-500',
		'dark:focus:ring-sky-500',
		'dark:placeholder-gray-400',
		'dark:text-white',
		'focus:border-sky-500',
		'focus:ring-sky-500',
	].join(' ')
	const [name, setName] = useState('')
	const [nip, setNIP] = useState('')
	const [gender, setGender] = useState(null)
	const [email, setEmail] = useState('')
	const [phone, setPhone] = useState('')
	const [password, setPassword] = useState('')
	const [showPassword, setShowPassword] = useState(false)
	const [errorMessage, setErrorMessage] = useState('')
	const [loading, setLoading] = useState(false)
	const handleSubmit = async (e) => {
		setLoading(true)
		e.preventDefault()
		try {
			const guest = await GuestLogin()
			await SetToken(guest.data.token)
			const res = await CreateUser({
				name: name,
				nip: nip,
				gender: gender?.value,
				email: email,
				phone: phone,
				password: password,
			})
			const token = await SetToken(res.data.token)
			const user = await Me(token.access_token)
			await SetUser(user?.data)
			alert(res?.data?.message?? 'Pendaftaran berhasil, cek email dan whatsapp anda dan klik tautan yang dikirim untuk verifikasi akun anda')
			let q = require('query-string').parse(props.location.search)
			if (q && q.redirect) {  
				window.location.replace(decodeURIComponent(q.redirect))
			} else {
				props.history.push('/')
			}
		} catch (e) {
			setErrorMessage(e?.response?.data?.error?.message?? 'Gagal terhubung ke server, silakan coba lagi nanti.')
			setTimeout(() => {
				setErrorMessage('')
			}, 3000)
		}
		setLoading(false)
	}
	return (
	<section>
		<div className="flex flex-col items-center justify-center px-6 py-8 mx-auto text-gray-800">
			{errorMessage && (
				<div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-red-500 text-white px-6 py-3 rounded-md shadow-md flex items-center">
					<span>{errorMessage}</span>
					<button className="ml-4 text-white focus:outline-none" onClick={() => setErrorMessage('')}>✖</button>
				</div>
			)}
			<div onClick={() => props.history.push('/')} className="flex items-center mb-4 text-2xl font-semibold dark:text-white cursor-pointer">
				<img className='transition ease-in-out hover:-translate-y-1 hover:scale-150 duration-300 h-[40px] my-[10px]' src={window.location.origin+"/assets/images/logo-pernik-hsi.png"} alt="logo"/>
			</div>
			<div className="w-full text-sm bg-white rounded-md shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
				<div className="p-6 space-y-4 md:space-y-6 sm:p-8">
					<h3 className="font-bold leading-tight tracking-tight text-center mb-4">
						Pendaftaran Akun Pernik HSI
					</h3>
					<form onSubmit={handleSubmit} className="space-y-4 md:space-y-6" action="#">
						<div>
							<label htmlFor="name" className="block mb-2 font-medium dark:text-white">Nama</label>
							<input onChange={(e) => setName(e.target.value)} name="name" id="name" className={inputClass} required autoFocus/>
						</div>
						<div>
							<label className="block mb-2 font-medium dark:text-white">Jenis Kelamin</label>
							<Select 
								placeholder="Pilih..."
								required
								value={gender} 
								onChange={(val) => setGender(val)} 
								options={[
									{value: 'male', label: 'Laki-laki'},
									{value: 'female', label: 'Perempuan'}
								]}
							  styles={{
							    control: (baseStyles, _state) => ({
							      ...baseStyles,
							      backgroundColor: 'rgb(249 250 251 / 1)',
							      padding: 2,
							      borderColor: 'rgba(var(--bs-gray-300-rgb), 1) !important',
							      borderRadius: '0.375rem',
							    }),
							  }}
							/>
						</div>
						<div>
							<label htmlFor="nip" className="block mb-2 font-medium dark:text-white">NIP HSI</label>
							<input onChange={(e) => setNIP(e.target.value)}  name="nip" id="nip" placeholder={gender?.value=='female'?'ART134-0001':'ARN134-0001'} className={inputClass}/>
						</div>
						<div>
							<label htmlFor="email" className="block mb-2 font-medium dark:text-white">Email</label>
							<input onChange={(e) => setEmail(e.target.value)}  type="email" name="email" id="email" placeholder="email@example.com" className={inputClass} required/>
						</div>
						<div>
							<label htmlFor="phone" className="block mb-2 font-medium dark:text-white">Nomor WhatsApp</label>
							<input onChange={(e) => setPhone(e.target.value)}  name="phone" id="phone" placeholder="081234567890" className={inputClass} required/>
						</div>
						<div className="relative">
							<label htmlFor="password" className="block mb-2 font-medium text-gray-900 dark:text-white">Kata Sandi</label>
							<input onChange={(e) => setPassword(e.target.value)} id="password" name="password" placeholder="••••••••" required type={showPassword ? "text" : "password"} className={inputClass}/>
							<div onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer" style={{ height: "100%", paddingTop: 25 }} >
								{showPassword ? (
									<svg className="w-5 h-5 text-gray-500 dark:text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="currentColor">
										<path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3" />
									</svg>
								) : (
									<svg className="w-5 h-5 text-gray-500 dark:text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="currentColor" focusable="false">
										<path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z" />
									</svg>
								)}
							</div>
						</div>
						<button type="submit" className="w-full text-white bg-sky-500 hover:bg-sky-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md px-5 py-2.5 text-center dark:bg-sky-500 dark:hover:bg-sky-700 dark:focus:ring-blue-800">
							{loading ? (
								<svg className="w-4 h-4 text-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
									<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
									<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
								</svg>
							) : (
								"Daftar"
							)}
						</button>
					</form>
					<p className="font-light text-gray-500 dark:text-gray-400 text-center mt-4">
						Sudah Punya Akun? <span className="font-medium text-sky-500 hover:underline dark:text-sky-500 cursor-pointer" onClick={() => props.history.push('/login')}>Login</span>
					</p>
				</div>
			</div>
		</div>
	</section>
	)
}